export  function spotlightSlider() {
    function sliderProgress(scrollbarLine, progress) {
        //scrollbarLine.css('width', value);
    }

    const sliderSelector = document.querySelectorAll(".spotlight-slider");

    if (sliderSelector.length) {
        sliderSelector.forEach(slider => {

            new Swiper(slider, {
                slidesPerView: 1,
                spaceBetween: 10,
                resistanceRatio: 0,
                scrollbar: {
                    el: ".swiper-scrollbar",
                    draggable: true,
                    hide: false,
                    dragSize: "40px",
                },
                breakpoints: {
                    568: {
                        slidesPerView: 2,
                        spaceBetween: 14,
                    },
                    1200: {
                        slidesPerView: 3,
                    },
                    1440: {
                        spaceBetween: 15,
                        slidesPerView: 3.285,
                    },
                    1800: {
                        spaceBetween: 22,
                        slidesPerView: 4,
                    },
                },
                on:{
                    progress: function() {
                        $(slider)[`${!this.progress ? 'add' : 'remove'}Class`]('isFirst');
                        $(slider)[`${this.progress>=1 ? 'add' : 'remove'}Class`]('isLast');

                        let scrollbarLine = $(slider).find('.scrollbar-line');
                        let value = Math.abs(this.progress) * 100 + '%';

                        scrollbarLine.css('clip-path', 'polygon(0 0, ' + value + ' 0, ' + value + ' 100%, 0 100%)');
                    }
                }
            });
        });
    }

//     let sliders = $(".spotlight-slider .swiper-container");
// console.log(sliders )
//     // var swiper = new Swiper(".swiper-container", {
//     //     slidesPerView: 3,
//     //     spaceBetween: 23,
//     //     scrollbar: {
//     //       el: ".swiper-scrollbar",
//     //       hide: false,
//     //       draggable: true,
//     //     },
//     //   });

//     sliders.each( slider =>  {console.log(slider)
//         var swiper = new Swiper(slider, {
//             slidesPerView: 3,
//             spaceBetween: 23,
//             scrollbar: {
//               el: ".swiper-scrollbar",
//               hide: false,
//               draggable: true,
//             },
//           });

        // let curSliderWrap = slider;
        // let curSlider = curSliderWrap.find(".swiper-container");

        // var swiper = new Swiper(curSlider, {
        //     watchSlidesVisibility: true,
        //     watchSlidesProgress: true,
        //     slidesPerView: 3,
        //     spaceBetween: 23,
        //     // scrollbar: {
        //     //     el: `.${curSliderWrap.find(".swiper-scrollbar").attr("class")}`,
        //     //     hide: false,
        //     //     dragSize: 14,
        //     //     draggable: true,
        //     // }
        // });
        // console.log(swiper)
    // });
    
}


// WEBPACK FOOTER //
// ./assets/js/modules/spotlightSlider.js